import { Context } from 'types/GlobalUserEvents'

export const getContextFromPath = (pathname: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, basePath, secondary] = pathname.split('/')

  switch (basePath) {
  case '':
    return Context.FROM_HOME_PAGE
  case 'admin':
    return Context.FROM_SETTINGS_PAGE
  case 'groups':
    return secondary ? Context.FROM_GROUP_PAGE : Context.FROM_GROUPS_PAGE
  case 'dashboards':
    if (secondary === 'favorites') {
      return Context.FROM_DASHBOARD_FAVORITES_PAGE
    }
    if (secondary === 'drafts') {
      return Context.FROM_DASHBOARD_DRAFTS_PAGE
    }

    return secondary
      ? Context.FROM_DASHBOARD_PAGE
      : Context.FROM_DASHBOARDS_PAGE
  case 'templates':
    return Context.FROM_EXPLORE_PAGE
  case 'metrics':
    return secondary ? Context.FROM_METRIC_PAGE : Context.FROM_METRICS_PAGE
  case 'key-metrics':
    return Context.FROM_KEY_METRICS_PAGE
  case 'entities':
    return secondary ? Context.FROM_ENTITY_PAGE : Context.FROM_ENTITIES_PAGE
  }

  return null
}
